export default function anniversary () {
    const discountSection = document.querySelector('.anniversary30-discount__action-copy');

    if (discountSection) {
    
        function copyCoupon() {
    
            const input = discountSection.querySelector('.anniversary30-discount__action-copy input');

            input.select();
            input.setSelectionRange(0, 99999);
    
            navigator.clipboard.writeText(input.value);
    
            discountSection.classList.add('copied');

            setTimeout(() => {
                discountSection.classList.remove('copied');
            }, 2500);
        }
    
        discountSection.addEventListener('click', copyCoupon);
    
    }

    const video = document.querySelector('.anniversary30-achievement__video');

    if (video) {
        video.addEventListener('click', () => {
            video.classList.add('play');
        });
    }
}